import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
  CarouselStatus,
  CarouselViewport,
} from "@loot-os/ui/components/carousel";

import type { HeroContent } from "../../pages/home/content/hero.js";
import { ClassicActionLink } from "../ClassicActionLink.js";

/**
 * The classic hero: a card from `md` up, with the art beside the copy; on a phone it sits on
 * the page, headline smaller, the actions sharing the width and the art square beneath them.
 */
export function ClassicHero({ headline, body, actions, artUrl }: HeroContent) {
  return (
    <Carousel className="w-full">
      <CarouselViewport>
        <CarouselPrevious className="hidden md:flex" />
        <CarouselContent>
          <CarouselItem className="w-full flex-1">
            <div className="relative flex flex-col gap-6 overflow-hidden md:min-h-80 md:flex-row md:items-center md:justify-between md:rounded-xl md:border md:border-border md:bg-card md:p-6">
              <div className="flex max-w-xl flex-col justify-center gap-6 md:gap-3">
                <h1 className="text-4xl leading-10 font-medium tracking-tight text-foreground md:text-6xl md:leading-none md:font-bold lg:text-7xl">
                  {headline}
                </h1>
                <div className="flex flex-col items-start gap-6 md:gap-4">
                  <p className="text-lg text-muted-foreground">{body}</p>
                  <div className="flex w-full gap-3 md:w-[19.5rem] md:gap-1">
                    {actions.map((action) => (
                      <ClassicActionLink
                        key={action.label}
                        action={action}
                        size="lg"
                        className="flex-1"
                      />
                    ))}
                  </div>
                </div>
              </div>
              {artUrl && (
                <img
                  src={artUrl}
                  alt=""
                  className="pointer-events-none aspect-square w-full rounded-2xl object-cover md:aspect-auto md:h-[26rem] md:w-auto md:max-w-[40%] md:self-center md:rounded-none md:object-contain"
                />
              )}
            </div>
          </CarouselItem>
        </CarouselContent>
        <CarouselNext className="hidden md:flex" />
      </CarouselViewport>
      <CarouselStatus />
    </Carousel>
  );
}
